<template>
  <span>
    <span v-show="workflow.sourceGrid">
      <b-form-select
        v-model="workflow.cellKey"
        :options="dataGrid_cellsSelect(workflow.sourceGrid)"
        size="sm"
      />
    </span>

    <span>in Table</span>
    <b-form-select
      v-model="workflow.sourceGrid"
      :options="dataGrid_select"
      size="sm"
      @change="sourceGridSelected"
    />

    <div class="mt-2" />

    <div v-if="workflow.sourceGrid">
      <Action
        v-for="(action, idx) in workflow.actions"
        :key="idx"
        :eventBus="eventBus"
        :actionIdx="idx"
        :actionType="action.type"
        :availableActions="availableActions"
        @actionSelected="actionSelected"
      >
        <AddRowTo
          v-if="action.type === 'addRowTo'"
          :eventBus="eventBus"
          :action="action"
          :actionIdx="idx"
          :sourceGrid="workflow.sourceGrid"
        />

        <UpdateUpdatedRow
          v-if="action.type === 'updateUpdatedRow'"
          :eventBus="eventBus"
          :action="action"
          :actionIdx="idx"
          :sourceGrid="workflow.sourceGrid"
        />
      </Action>
    </div>

    <AddActionBtn
      v-if="workflow.sourceGrid && workflow.actions"
      :eventBus="eventBus"
      :actionsCount="workflow.actions.length"
    />
  </span>
</template>

<script>
import { mapGetters } from 'vuex'
// components
import AddActionBtn from '../../AddActionBtn'
import Action from '../../Action'
import AddRowTo from './actions/AddRowTo'
import UpdateUpdatedRow from './actions/UpdateUpdatedRow'

export default {
  props: ['eventBus', 'workflow'],
  components: {
    AddActionBtn,
    Action,
    AddRowTo,
    UpdateUpdatedRow,
  },
  computed: {
    ...mapGetters(['dataGrid_select', 'dataGrid_title', 'dataGrid_cellsSelect']),
    availableActions() {
      return [
        { text: 'Add a new row to table', value: 'addRowTo' },
        {
          text: `Update updated "${this.workflow.sourceGrid}" row value`,
          value: 'updateUpdatedRow',
        },
      ]
    },
  },
  methods: {
    sourceGridSelected() {
      if (!this.workflow.actions) this.eventBus.$emit('addAction')
    },
    actionSelected(type, idx) {
      const curAction = this.workflow.actions[idx]

      switch (type) {
        case 'updateUpdatedRow':
          this.eventBus.$emit(
            'setAction',
            Object.assign({}, curAction, { writeMethods: [{ type: 'expression' }] }),
            idx
          )
          break
      }
    },
  },
}
</script>
